import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'tangram-analytics-filter-bar',
  templateUrl: './analytics-filter-bar.component.html',
  styleUrls: ['./analytics-filter-bar.component.scss']
})
export class AnalyticsFilterBarComponent {
  @Input() mediaType = 'all';
  @Input() studentQuery = '';
  @Output() mediaTypeChange = new EventEmitter<string>();
  @Output() studentQueryChange = new EventEmitter<string>();
}
